

export default {

    name: 'project',
    component: () => import('@/layouts/ProjectInfoLayout.vue'),
    children: [
        {
            path: ':projectId/revision',
            name: 'revision',
            component: () => import('@/modules/reviewModule/views/ProjectReview.vue'),
            meta : {requiresAuth : true, allowedUserTypes: [ 1, 2, 3 ]}
        },
        {
            path: ':projectId/samples',
            name: 'muestras',
            component: () => import('@/modules/samplesModule/views/ProjectSamples.vue'),
            meta : {requiresAuth : true, allowedUserTypes: [ 1, 3 ]}
        },
        // {
        //     path: ':projectId/feedback',
        //     name: 'feedback',
        //     component: () => import('@/modules/feedbackModule/views/ProjectFeedback.vue'),
        //     meta : {requiresAuth : true, allowedUserTypes: [ 1, 3 ]}
        // },
        {
            path: ':projectId/showTxt:txt',
            name: 'showTxt',
            component: () => import('@/modules/reviewModule/views/ShowTxt.vue'),
            meta : {requiresAuth : true, allowedUserTypes: [ 1, 2, 3 ]}
        },
        

    ]


}